import './index.scss'
import '../../assets/scripts/number.js'
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".section2").offset().top - $(".section2").height() * 1.5  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".section2").offset().top - $(".section2").height() * 1.5 && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})